import { translationConnectAi_da } from "./translationConnectAi.da";
import { defineBilingualTranslations } from "./translationTypes";
import { translationConnectAi_en } from "./translationConnectAi.en";

export const translationConnectAi = defineBilingualTranslations({
  da: translationConnectAi_da,
  en: translationConnectAi_en,
});
